export default __webpack_public_path__ + "static/media/novice-guide-cn.8105d025.png";